/**
 * @param {Object} props
 * @param {Array<number>} props.enabled_ids
 * @param {Array<number>} props.counts
 * @param {Array<{ id: number, name: string }>} props.condition_items
 * @param {Function} props.resetPageNum
 * @param {Function} props.filter
 * @param {string} props.condition_param
 * @param {boolean} props.show_chosen
 * @param {boolean} props.withoutDivider
 * @param {boolean} props.withoutTopPadding
 * @param {boolean} props.orMode
 * @returns {JSX.Element|null}
 * @constructor
 */
export default function FilterCondition(props) {
  let selectedIds = props.enabled_ids || [];
  selectedIds = selectedIds instanceof Array ? selectedIds : [selectedIds];

  const handleChange = (event) => {
    let value = parseInt(event.target.value);
    if (isNaN(value)) value = event.target.value;

    const indexOfValue = selectedIds.indexOf(value);
    if (indexOfValue < 0) {
      selectedIds.push(value);
    } else {
      selectedIds.splice(indexOfValue, 1);
    }

    props.resetPageNum?.();

    props.filter(props.condition_param, selectedIds);
  };

  const conditionBlock = (category, key) => (
    <label className='mdc-form-field filter-row__check' key={key}>
      <div className='mdc-checkbox'>
        <input
          className={`mdc-checkbox__native-control input_${props.condition_param}${category.id}`}
          type='checkbox'
          onClick={(event) => event.stopPropagation()}
          onChange={handleChange}
          value={category.id}
          checked={selectedIds.includes(category.id)}
        />
        <div className='mdc-checkbox__background'>
          <svg className='mdc-checkbox__checkmark' viewBox='0 0 24 24'>
            <path className='mdc-checkbox__checkmark-path' fill='none' d='M1.73,12.91 8.1,19.28 22.79,4.59' />
          </svg>
          <div className='mdc-checkbox__mixedmark' />
        </div>
      </div>
      <div className='mdc-checkbox__label'>
        {category.name}&nbsp;&nbsp;
        {props.counts && !selectedIds.includes(category.id) &&
          <span className={"mdc-checkbox__label-count"}>
            {selectedIds.length > 0 && props.orMode ? '+' : ''}{props.counts[category.id] ?? 0}
          </span>
        }
      </div>
    </label>
  );

  const conditionsToRender = () => {
    let conditionItems = props.condition_items;
    if (props.show_chosen) {
      conditionItems = conditionItems.filter((item) => selectedIds.includes(item.id));
    }
    if (props.counts) {
      conditionItems = conditionItems.filter((item) => selectedIds.includes(item.id) || props.counts[item.id] > 0);
    }

    return conditionItems;
  }

  const conditionsBlock = () => {
    return conditionsToRender().map(conditionBlock);
  };

  if (props.condition_items == null) return null;
  if (conditionsToRender().length == 0) return null;
  if (props.show_chosen && (!selectedIds || !selectedIds.length)) return null;

  let className = 'filter-row';
  if (props.withoutDivider) className += ' filter-row_without_divider';
  if (props.withoutTopPadding) className += ' filter-row_without_top-padding';

  return (
    <div className={className}>
      {props.condition_name?.length > 0 && <div className={'filter-row__title'}>{props.condition_name}</div>}

      {conditionsBlock()}
    </div>
  );
}
